import fetcher from 'api/fetcher';
import { getPreparedAppliedCampaignsFilters } from 'utils/campaigns';

import { urlParser } from '@hh.ru/browser-api-utils';

import { CampaignsCounts, CampaignsTab, setCampaignsCounts } from 'store/models/campaignsDashboard';
import { AppThunkAction } from 'store/utils';

export const fetchCampaignsCounts = (abortSignal: AbortSignal): AppThunkAction<Promise<CampaignsCounts>> => {
    return (dispatch, getState) => {
        const state = getState();
        const appliedCampaignsFiltersTotalCount = state.campaignsFilters.appliedCampaignsFiltersTotalCount;
        const appliedCampaignsFilters = state.campaignsFilters.appliedCampaignsFilters;
        const campaignSearchValue = state.campaignsFilters.campaignsSearchValue;

        const queryStr = urlParser.stringify({
            nameFilter: campaignSearchValue,
            ...getPreparedAppliedCampaignsFilters(appliedCampaignsFilters, appliedCampaignsFiltersTotalCount),
        });

        return fetcher
            .get<unknown, CampaignsCounts>(`/api/v2/campaigns/count?${queryStr}`, {
                signal: abortSignal,
                timeout: 30000,
            })
            .then((campaignCounts) => {
                const counts: CampaignsCounts = {
                    [CampaignsTab.All]: campaignCounts.all || 0,
                    [CampaignsTab.Active]: campaignCounts.active || 0,
                    [CampaignsTab.Paused]: campaignCounts.paused || 0,
                    [CampaignsTab.Attention]: campaignCounts.attention || 0,
                    [CampaignsTab.Archived]: campaignCounts.archived || 0,
                };

                dispatch(setCampaignsCounts(counts));

                return counts;
            });
    };
};
